import api from "@/assets/scripts/api";
import { sortMaterialsByFreshness } from "@/assets/scripts/common";
import { hexToRGB } from "@/assets/scripts/utils";
import http from "@/plugins/http";
import html2canvas from "html2canvas";
// 文字校验
export const textCheck = async text => {
  let { code, data } = await http.post(api.textCensor, {
    text,
  });
  if (code === 10000 && data.conclusionType === 0) {
    return true;
  }
  return false;
};
// 压缩
export const compress = async formData => {
  const res = http.postDown(api.compress, formData);
  return res;
};
// 上传图片
export const uploadImg = async formData => {
  const res = http.postDown(api.uploadImage, formData);
  return res;
};
export const randomSort = list => {
  return list.sort(() => {
    return Math.random() > 0.5 ? -1 : 1;
  });
};
const COLOR_TAG_IDS = [1, 2, 3, 4, 5, 6];
let backgroundColorMapPromise = null;
// 素材 id -> 色系标签。专题页自身色系可能和 banner 背景不一致，做同款时用来对齐风格库
export const getBackgroundColorMap = () => {
  if (!backgroundColorMapPromise) {
    backgroundColorMapPromise = Promise.all(
      COLOR_TAG_IDS.map(tagId => getBackgrounds(tagId, null).catch(() => []))
    )
      .then(lists => {
        const map = {};
        lists.forEach((list, index) => {
          const tagId = COLOR_TAG_IDS[index];
          (list || []).forEach(item => {
            const id = Number(item.id);
            if (!map[id]) map[id] = [];
            if (!map[id].includes(tagId)) map[id].push(tagId);
          });
        });
        return map;
      })
      .catch(error => {
        backgroundColorMapPromise = null;
        throw error;
      });
  }
  return backgroundColorMapPromise;
};
export const resolveSameStyleTagId = (pageTagId, materialTagIds) => {
  const tags = (materialTagIds || []).map(Number).filter(id => COLOR_TAG_IDS.includes(id));
  const pageTag = Number(pageTagId);
  if (!tags.length) return pageTagId || "";
  if (tags.includes(pageTag)) return pageTag;
  return tags[0];
};
export const getBackgrounds = async (tagId, platformType, pageIndex, pageSize) => {
  const params = {
    tagId,
    pageSize: pageSize || 10000,
    pageIndex: pageIndex || 0,
  };
  if (platformType !== null) params.platformType = platformType || 1;
  let result = await http.get(api.backgrounds, params);
  if (result.code === 10000 && result.data.list) {
    return sortMaterialsByFreshness(result.data.list);
  }
  return [];
};
export const getElements = async (tagId, platformType, pageIndex, pageSize) => {
  let result = await http.get(api.elements, {
    tagId,
    platformType: platformType || 1,
    pageSize: pageSize || 10000,
    pageIndex: pageIndex || 0,
  });
  return sortMaterialsByFreshness(result.data.list);
};
export const getTagColor = async () => {
  let { data } = await http.get(api.tag);
  let colorList = data.list[0].tags;
  let styleList = data.list[2].tags;
  colorList.forEach(item => {
    let colorArray = item.tagValue.split(",");
    item.selectColor = colorArray[1];
    item.hoverColor = `rgba(${hexToRGB(colorArray[2]).join(",")},.4)`;
  });
  styleList.forEach(item => {
    item.selectColor = "#D63428";
    item.hoverColor = `rgba(${hexToRGB(item.tagValue).join(",")},.4)`;
  });
  return [...colorList, ...styleList];
};
export const htmlToCanvas = async (coverDom, scale, backgroundColor = null) => {
  // 获取设备像素比，确保在不同设备上保持一致
  const devicePixelRatio = window.devicePixelRatio || 1;
  const actualScale = scale || devicePixelRatio;
  const options = {
    width: coverDom.offsetWidth,
    height: coverDom.offsetHeight,
    scale: actualScale,
    useCORS: true,
    allowTaint: true,
    taintTest: false,
    imageTimeout: 0,
  };
  if (backgroundColor) {
    options.backgroundColor = backgroundColor;
  }
  let canvas = await html2canvas(coverDom, options);
  return canvas.toDataURL("image/png", 1);
};

export const htmlToCanvasWithBackground = async (coverDom, scale, backgroundColor = null) => {
  // 获取设备像素比，确保在不同设备上保持一致
  const devicePixelRatio = window.devicePixelRatio || 1;
  const actualScale = scale || devicePixelRatio;
  const options = {
    width: coverDom.offsetWidth,
    height: coverDom.offsetHeight,
    scale: actualScale,
    useCORS: true,
    allowTaint: true,
    taintTest: false,
    backgroundColor: backgroundColor,
    imageTimeout: 0,
  };
  let canvas = await html2canvas(coverDom, options);
  return canvas.toDataURL("image/png", 1);
};

// 获取头像列表
export const getPortraits = async (query = {}) => {
  const defaultParam = {
    pageIndex: 1,
    pageSize: 1000,
  };
  const params = Object.assign({}, defaultParam, query);
  !params.teacherName && delete params.teacherName;
  let res = await http.get(api.portraits, params);
  if (res && res.code === 10000 && res.data.list) {
    return res.data;
  }
  return {
    list: [],
    totalCount: 0,
  };
};
// 获取虚拟形象列表
export const getVirtualPortraits = async (query = {}) => {
  const defaultParam = {
    pageIndex: 1,
    pageSize: 1000,
  };
  const params = Object.assign({}, defaultParam, query);
  (params.gender === undefined || params.gender === "") && delete params.gender;
  const res = await http.get(api.virtualPortraits, params);
  if (res && res.code === 10000 && res.data.list) {
    return res.data;
  }
  return {
    list: [],
    totalCount: 0,
  };
};
export const batchUploadVirtualPortraits = async formData => {
  return await http.postDown(api.batchUploadVirtualPortraits, formData);
};
// 获取size详情
export const getSizeInfo = async id => {
  let { code, data } = await http.get(api.sizeInfo + "?id=" + id);
  if (code === 10000 && data) {
    return data;
  }
  return {};
};
// 根据sizeId获取文字样式
export const getTextStylesBySizeId = async id => {
  let { code, data } = await http.get(`${api.textStyle}?sizeId=${id}`);
  if (code === 10000) {
    return data.list;
  }
  return [];
};
